import { Navigate, Outlet } from "react-router-dom";
import { useSession } from "@/hooks/useSessionHook";

/**
 * Ensures the logged-in user has completed age verification.
 * For now: self-attestation stored on the profile row.
 */
export default function AgeVerifiedRoute() {
  const { profile } = useSession();

  // AuthProtectedRoute already ensures session exists; here we just wait for profile.
  if (!profile) {
    return <div className="w-full h-screen flex items-center justify-center">Loading profile...</div>;
  }

  const ageVerified = profile.age_verified === true;

  if (!ageVerified) {
    return <Navigate to="/age-gate" replace />;
  }

  return <Outlet />;
}
